/* eslint-disable prettier/prettier */
<template>
	<div id="app">
		<ModalIdle v-if="isIdle" />
		<ModalLoading />
		<router-view />
	</div>
</template>

<script>
import $ from "jquery";
import httpService from "@/http/http-common.js";
import Cookies from "js-cookie";
import ModalIdle from "@/components/ModalIdle.vue";
import ModalLoading from "@/components/ModalLoading.vue";


export default {
	name: "app",
	components: {
		ModalIdle,
		ModalLoading
	},
	methods: {
		gdprOnAccept() {
			Cookies.set("GDPR", "true");
			$("#cookieTxt").hide();
		},
	},
	mounted() {
		if (!localStorage.language) {
			localStorage.language = "el-GR";
		}

		if (Cookies.get("GDPR")) {
			$("#cookieTxt").hide();
		} else {
			$("#cookieTxt").show();
		}
		httpService.commonsService.getConfigFile(
			localStorage.language,
			"beneficiary"
		);
	},
	created() {
		if (!localStorage.language) {
			localStorage.language = "el-GR";
		}
	},
	computed: {
		isIdle() {
			return this.$store.state.idleVue.isIdle;
		},
	},
	destroyed() {
		localStorage.clear();
		sessionStorage.clear();
		Cookies.clear();
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

#nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}

.language-button {
	padding: 5px;
	cursor: pointer;
	font-size: 22px;
	opacity: 0.5;
}

.language-div {
	text-align: right;
	padding-right: 10px;
	padding-top: 5px;
	height: 30px;
}</style>
